export default "/kiban/_next/static/images/logo-7b010b101fbc8487e873773aa47bcde2.png";